

export default class API_CONST {
  public static readonly API_ROOT = 'http://api.root.endpoint';
  public static readonly GET_USER_ROLE = `${API_CONST.API_ROOT}/role`;
  public static readonly GET_USER_INFO = `${API_CONST.API_ROOT}/userinfo`;
  public static readonly GET_USER_POST = '/posts';
  public static readonly FORGOT_PASSWORD = 'users/password/forgot';
  public static readonly NOTIFY_INVITAION_EXPIRED = 'users/token/notify';
  public static readonly LOGIN = 'users/authenticate';
  public static readonly SET_PASSWORD = 'users/password';
  public static readonly VALIDATE_TOKEN = 'users/token/validation';
  public static readonly LOGOUT = 'users/logout';
  public static readonly USERID = 'Users/';
  public static readonly UPDATE_PROFILE = 'users/profile';
  public static readonly CHANGE_PASSWORD = 'users/password/change';
  public static readonly ACCOUNT_ID = 'accounts';
  public static readonly FETCH_CONFIG_PROGRAM = 'programs';
  public static readonly RESEND_INVITE = '/users/resend-invite';
  public static readonly PROGRAMS = 'programs';
  public static readonly ACCOUNT_BY_ID = 'accounts';
  public static readonly USER_INFORMATION = 'users/info';
  public static readonly GET_DROPDOWN_SCHOLARS = '/guardian/#/availableScholarsForApplication';
  public static readonly DELETE_SCHOLAR_IDS = 'cart/RemoveCartScholars/';
  public static readonly CREATE_GUARDIAN = 'guardian';
  public static readonly VALIDATE_GUARDIAN_TOKEN = 'guardian/token/validation';
  public static readonly SET_GUARDIAN_PASSWORD = 'guardian/password';
  public static readonly FORGOT_GUARDIAN_PASSWORD = 'guardian/password/forgot';
  public static readonly UPDATE_GUARDIAN = 'guardian';
  public static readonly APPLICATION_DATA = 'application/data/';
  public static readonly SITES = 'sites';
  public static readonly APPLICATION = 'application';
  public static readonly SAVE_FORMS_ELASTIC = 'enrollment/elastic';
  public static readonly ELASTIC_ENROLLMENT = 'enrollment';
  public static readonly ELASTIC_ENROLLMENT_BY_SCHOLAR = 'enrollment/scholar';
  public static readonly PROGRAM_SITES_BY_ACC_ID = 'accounts/accprogsiteinfo';
  public static readonly GET_CHILDREN_BY_GUARDIAN = 'guardian';
  public static readonly GET_SCHOLAR_INFO_BY_GUARDIAN = 'guardian/scholarsinfo';
  public static readonly GET_APPLICATIONS_BY_GUARDIAN = 'enrollment/guardian';
  public static readonly GET_ENROL_WAITLIST_COUNT = 'enrollment/program-card';
  public static readonly GET_ADDED_SCHOLAR = 'roster/scholar';
  public static readonly UPDATE_SCHOLAR_DATA = 'roster/scholar/';
  public static readonly APPLICATION_DOCUMENT = 'application/applicationdocument/';
  public static readonly SCHOLAR_DOCUMENT = 'roster/scholar/site/documents';
  public static readonly DOCUMENT_DOWNLOAD = 'scholardocs/';
  public static readonly GET_ENROLLED_APPLICATIONS = 'application/enrolled';
  public static readonly SCHOLAR_INFO = '/enrollment/info';
  public static readonly PROGRAMS_DETAILS = '/family/programs';
  public static readonly ACCOUNT_SLUG = '/accounts/slug';
  public static readonly UPDATE_AUTHORIZE_PICKUP = 'family/authorizedpickup';
  public static readonly UPDATE_PROGRAM_DETAILS = 'family/programdetails';
  public static readonly GUARDIAN_INFO = 'guardian';
  public static readonly UPDATE_DOCUMENT = 'roster/scholar/updatedocument';

  public static readonly GUARDIANS_INVITE_EMERGENCY_CONTACT = '/guardian/invite/emergencyContact';
  public static readonly GUARDIANS_INVITE_AUTHORIZED_PICKUP = '/guardian/invite/pickup';

  public static readonly SESSION_CATALOG = 'catalog/programSessionCatalog';
  public static readonly SESSION_CATALOG_FILTERS = 'catalog/programSessionCatalogFilters';
  public static readonly ASSOCIATE_SCHOLAR = 'enrollment/associateScholar';
  public static readonly PAYMENT_ONBOARDING_STATUS = 'payment/onboarding-status';

  public static readonly CART_GET = 'cart';
  public static readonly CART_ADD_CART_ITEM = 'cart/addcartitem';
  public static readonly CART_UPDATE_CART_ITEM = 'cart/updatecartitem';
  public static readonly CART_GET_CART_APPLICATIONS = 'cart/cartapplications';
  public static readonly CART_SUBMIT = 'cart/submitOrder';

  public static readonly STRIPE_SETUP_INTENT = 'guardian/setupIntent';
  public static readonly CART_REMOVE_CART_ITEM = 'cart/removeCartItem';
  public static readonly TERMS_OF_SERVICE = 'accounts/policy';
  public static readonly CUSTOM_CHECKOUT = '/customcheckout';

  public static readonly DISCOUNT = '/discount';

  public static readonly STRIPE_CUSTOMER_PORTAL_SESSION = '/guardian/get-customer-portal-for-guardian';
}